import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import { VmsFilterapi } from "../../API/API";
import { alertNotification } from "../../components/TopNotification/alertNotification";

function* getVmsFilterList(action) {
  try {
    const response = yield call(() => VmsFilterapi(action.payload));
    yield put({
      type: types.FETCH_VMS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({ type: types.FETCH_VMS_FAILURE, error });
    alertNotification("error", "Failed to fetch VMS filter list");
  }
}

export function* watchGetVmsFilterSaga() {
  yield takeEvery(types.FETCH_VMS_REQUEST, getVmsFilterList);
}
